import { useCallback } from 'react'

/** Dispatches into oap-web's CRM store via module federation (only runs on user action). */
export const useOpenStandardEmailComposerFromHost = () => (
  useCallback(async (recipient, onSendSuccess) => {
    try {
      const mod = await import(
        /* webpackChunkName: "oap_web_host_standard_email_composer" */
        'oap_web/HostStandardEmailComposer',
      )

      mod.openStandardEmailComposerFromHost?.(recipient, onSendSuccess)
    } catch {
      // Remote missing/outdated — intentionally no-op.
    }
  }, [])
)
